import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Enquires } from '../../models/enquires';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnquiresService extends ResourceService<Enquires> {
  /**
   * @constructor
   * Creates an instance of the EnquiresService
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
 */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'enquiries');
  }

 /**
  * Sends a POST request to the /enquiries endpoint
  * @remarks
  * to create an assisted booking which is seen on admin's end
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  createEnquiry(payload: Enquires) {
    return this.http.post<any>(`${this.endpoint}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

   /**
  * Sends a GET request to the /enquiries endpoint
  * @remarks
  * to get all enquires created via assisted booking
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  getAllEnquires() {
    return this.http.get<any>(`${this.endpoint}`)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }


   /**
  * Sends a GET request to the /enquiries/:id endpoint
  * @remarks
  * to get detail of an enquiry
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  getEnquiryById(id: string) {
    return this.http.get<any>(`${this.endpoint}/${id}`)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}/${id}`);
        return resp;
      }))
  }


   /**
  * Sends a PUT request to the /enquiries/:id endpoint
  * @remarks
  * to update the status of an enquiry
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  updateEnquiry(id: string, payload: {status: string}) {
    return this.http.put<any>(`${this.endpoint}/${id}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}/${id}`);
        return resp;
      }))
  }

   /**
  * Sends a PUT request to the /enquiries/response endpoint
  * @remarks
  * to send an enquiry response from the response to the admin(CS TEAM)
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  sendEnquiryResponse(payload: any[]) {
    return this.http.put<any>(`${this.endpoint}/response`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/response`);
        this.cache.remove(`${this.endpoint}/response`);
        return resp;
      }))
  }


   /**
  * Sends a POST request to the /enquiries/request endpoint
  * @remarks
  * to send an enquiry request from the Admin(CS Team) to the Supllier
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  sendEnquiryRequest(payload: any) {
    return this.http.post<any>(`${this.endpoint}/requests`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/requests`);
        this.cache.remove(`${this.endpoint}/requests`);
        return resp;
      }))
  }

   /**
  * Sends a GET request to the /enquiries/request?enquiryId:/id endpoint
  * @remarks
  * to pool properties/request sent to supplier via email. The enquiry id is gotten from the mail
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  getEnquiryRequest(id: string) {
    return this.http.get<any>(`${this.endpoint}/enquiries/requests?enquiryId=${id}`)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/enquiries/requests?enquiryId=${id}`);
        this.cache.remove(`${this.endpoint}/enquiries/requests?enquiryId=${id}`);
        return resp;
      }))
  }
  updateEnquiryResponse(requestId: string, listingId: string, payload: {status: string}) {
    return this.http.put<any>(`${this.endpoint}/response/status/${requestId}/${listingId}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/response/status/${requestId}/${listingId}`);
        this.cache.remove(`${this.endpoint}/response/status/${requestId}/${listingId}`);
        return resp;
      }))
  }
  


}
